'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Typography = require('../../../../../common/components/Typography.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const ClaimDetailsDescriptionListStyled = styled__default["default"].dl.withConfig({
  componentId: "sc-14eh5pg-0"
})(["margin:0;"]);
const ClaimDetailsDescriptionList = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescriptionListStyled, rest, children);
};
const ClaimDetailsDescriptionContainer = styled__default["default"].div.withConfig({
  componentId: "sc-14eh5pg-1"
})(["display:grid;grid-template-columns:1fr;gap:0.75rem;"]);
const ClaimDetailsDescriptionRow = styled__default["default"].div.withConfig({
  componentId: "sc-14eh5pg-2"
})(["display:grid;grid-template-columns:1fr 1fr;gap:1rem;"]);
const ClaimDetailsDescriptionStyled = styled__default["default"].div.withConfig({
  componentId: "sc-14eh5pg-3"
})(["display:flex;flex-direction:column;gap:0.25rem;"]);
const Value = styled__default["default"].dd.withConfig({
  componentId: "sc-14eh5pg-4"
})(["line-break:anywhere;margin:0;"]);
const ClaimDetailsDescriptionValue = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/React__default["default"].createElement(Value, null, /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, null, children));
};
const ClaimDetailsDescriptionLabel = _ref3 => {
  let {
    children
  } = _ref3;
  return /*#__PURE__*/React__default["default"].createElement("dt", null, /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, null, children));
};
const ClaimDetailsDescription = _ref4 => {
  let {
    label,
    value
  } = _ref4;
  return /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescriptionStyled, null, /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescriptionLabel, null, label), /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescriptionValue, null, value));
};

exports.ClaimDetailsDescription = ClaimDetailsDescription;
exports.ClaimDetailsDescriptionContainer = ClaimDetailsDescriptionContainer;
exports.ClaimDetailsDescriptionLabel = ClaimDetailsDescriptionLabel;
exports.ClaimDetailsDescriptionList = ClaimDetailsDescriptionList;
exports.ClaimDetailsDescriptionListStyled = ClaimDetailsDescriptionListStyled;
exports.ClaimDetailsDescriptionRow = ClaimDetailsDescriptionRow;
exports.ClaimDetailsDescriptionValue = ClaimDetailsDescriptionValue;
